import fallbackLandscape from 'assets/images/landscape_fallback.png';
import fallbackPortrait from 'assets/images/portrait_fallback.png';
import { cardMargin } from 'components/Lane/Lane.css';
import { Breakpoint } from 'style/styled-components/cssMediaQueries';

export enum CardVariant {
    LANDSCAPE = 'landscape',
    LANDSCAPE_LARGE = 'landscape_large',
    PORTRAIT = 'portrait',
    CHANNEL = 'channel',
    CIRCLE = 'circle',
}

const BANNER_IMAGE_WIDTH = 1920;
const BANNER_IMAGE_HEIGHT = 600;
const BANNER_UNDERSHOOT = 48;

const bannerWidth = `calc(100% - ${BANNER_UNDERSHOOT}px)`;

export type GridWidths = { base: string } & Partial<Record<Breakpoint, string>>;

export type CardDimensions = {
    width: string;
    maxWidth: string;
    aspectRatio?: string;
    scrollMarginLeft?: string;
    imageHeight?: string;
    imageAspectRatio?: string;
    cardHeight?: string;
    expandedCardHeight?: string;
    infoHeight?: string;
    insetPortraitWidth?: string;
};

export type CardVariantSpec = CardDimensions & {
    showInfo?: boolean;
    showInsetPortrait?: boolean;
    wrapperClassName?: string;
    testId?: string;
    fallbackImage?: string;
    insetFallbackImage?: string;
    gridWidths?: GridWidths;
    responsive?: Partial<Record<Breakpoint, Partial<CardDimensions>>>;
};

export const CARD_VARIANTS: Record<CardVariant, CardVariantSpec> = {
    [CardVariant.LANDSCAPE]: {
        width: '288px',
        maxWidth: 'none',
        imageHeight: '162px',
        imageAspectRatio: '16 / 9',
        cardHeight: '204px',
        expandedCardHeight: '228px',
        infoHeight: '44px',
        insetPortraitWidth: '120px',
        showInfo: true,
        showInsetPortrait: true,
        wrapperClassName: 'wide-tile',
        testId: 'tv-tvcards-tvseries',
        fallbackImage: fallbackLandscape,
        insetFallbackImage: fallbackPortrait,
        gridWidths: { base: '50%', s: '33.333%', m: '25%', xxxl: '20%' },
    },
    [CardVariant.LANDSCAPE_LARGE]: {
        width: bannerWidth,
        maxWidth: `${BANNER_IMAGE_WIDTH}px`,
        aspectRatio: `${BANNER_IMAGE_WIDTH} / ${BANNER_IMAGE_HEIGHT}`,
        scrollMarginLeft: `${cardMargin}px`,
        imageHeight: '100%',
        showInfo: false,
        showInsetPortrait: false,
        wrapperClassName: 'promo-tile',
        testId: 'tv-promo-banner',
        fallbackImage: fallbackLandscape,
    },
    [CardVariant.PORTRAIT]: {
        width: '176px',
        maxWidth: 'none',
        cardHeight: '264px',
        imageAspectRatio: '2 / 3',
        showInfo: true,
        showInsetPortrait: false,
        wrapperClassName: 'tile',
        testId: 'card-portrait-wrapper',
        fallbackImage: fallbackPortrait,
        gridWidths: { base: '50%', xxs: '33.33%', s: '20%', m: '16.66%', l: '14.28%', xl: '12.5%', xxl: '11.11%' },
    },
    [CardVariant.CIRCLE]: {
        width: 'auto',
        maxWidth: 'none',
    },
    [CardVariant.CHANNEL]: {
        width: '176px',
        maxWidth: 'none',
        cardHeight: '99px',
        gridWidths: { base: '50%', xxs: '33.33%', xs: '25%', s: '20%', m: '16.66%', l: '14.28%', xl: '12.5%', xxl: '11.11%' },
    },
};

export const cardSpec = (variant: CardVariant): CardVariantSpec => CARD_VARIANTS[variant];
